import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import block from 'bem-cn';

import Spinner from 'components/Spinner';

import useGeneralModel from '../model/useGeneralModel';

import FilterBlock from './FilterBlock';
import Table from './Table/Table';
import TableProviders from './TableProviders/TableProviders';

import './GeneralReport.scss';

const b = block('general-report');

const GeneralReport = () => {
  const { actionProcessing } = useSelector(state => state.generalReport, shallowEqual);
  const locale = useSelector(state => state.locale.locale);

  const { handlers, values } = useGeneralModel();

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing} />
      <div className={b('title')}>{locale.generalReport}</div>
      <FilterBlock handlers={handlers} values={values} />
      <Table values={values} handlers={handlers} />
      <TableProviders handlers={handlers} values={values} />
    </div>
  );
};

export default GeneralReport;
